import { InvitesSentModal } from './InvitesSentModal';
import { InvitesSkippedModal } from './InvitesSkippedModal';
import { SendInvitesModal } from './SendInvitesModal';

const InviteModal = () => {
  return (
    <>
      <SendInvitesModal />
      <InvitesSentModal />
      <InvitesSkippedModal />
    </>
  );
};

export default InviteModal;
